var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManufacturer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 31,
    fill: "url(#pattern0_3576_3623)",
    style: {
      mixBlendMode: "darken"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3576_3623",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3576_3623",
    transform: "matrix(0.0105263 0 0 0.0112054 0 -0.00424448)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3576_3623",
    width: 95,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF8AAABaCAYAAADegYpGAAAChklEQVR4AezaW26DMBCFYZpFZP/ryyZa+QEJEB6P7TkMNH8llMSXM/bHPPa18JcmAH4a/bKAD36iQGJpOh/8RIHE0nQ++IkCiaXp/A3++/3+VTybEruv4O84rv0BvuUtngNfDGzFg2/piOfAFwNb8eBbOuI58MXAVjz4lo54DnwxsBUPvqUjngNfDGzFg2/piOceji/WEceDLwa24sG3dMRz4IuBrXjwLR3xHPhiYCsefEtHPAe+GNiKB9/SEc+BLwa24sG3dMRzanzx8Z8dD37i+wMffK1A+RdAbYWx9NDOL5csz9hR9rtKTnn2o/2/IjL6q/p2hOKvJWcvvN2//b7mj3xG5YzUru0Jw7/j5Y5nOv6uoVw1HoJ/dqmzMc+lzvadjXmy7r4mBL92yV603vW1umW8llUbL3uufqbxr7pMT53W2tb8VS9hCt9zCc+aclnPOs+akvWU53WHg0aierO865Q+w53fc/ieta3L3jWrde6z+WH8szBrrIZWG7eyanORWbUakeND+FGXHM0523c25oEa3efJbq3pxp857Mze40XumnU8p/W7G98K88ytaOunZ09rTWRWq1bkfBd+1CUjcyKzImE9WW78qEt6DvUta9z43wJy5T1d+HS95pW48DWln5CqPWMTn67XvYAmvq40yeAn9gD44CcKJJam88FPFEgsTeeDnyiQWJrOB39Y4NEb6fzE1wc++IkCiaXpfPATBRJL0/ngJwoklqbzwU8USCxN5/9n/MS73b40nZ/4isAHP1EgsTSdD36iQGJpOh/8RIHE0s3O/3w+PzxzBrX328SvbWR8XgD8ecPhhNcyvJWNswJ0/qzgxH7wJ/Bmt4I/Kzix/w8AAP//6/A+MgAAAAZJREFUAwD02ETENOACvgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturer);
export default __webpack_public_path__ + "static/media/manufacturer.fc1358114b0b71f30caf428ccee3fa03.svg";
export { ForwardRef as ReactComponent };